import moment from 'moment';

const formatDate = (date: Date | string) => {
  const momentDate = moment(date);
  const difference = momentDate.diff(moment(), 'hours');

  if (difference < -24) {
    return momentDate.format('D MMM');
  }
  if (difference < -1) {
    return `${Math.abs(difference)}h`;
  }
  return `${Math.abs(momentDate.diff(moment(), 'minutes'))}m`;
};

export default formatDate;
